import { Popover } from '@atgfr8/atg-ui-tailwind';
import { JSXElement, Show, createSignal } from 'solid-js';

export const HoverPop = (props: {
  children: JSXElement;
  anchor: JSXElement;
  render: boolean;
  marginTop?: string;
}) => {
  //Popover Boilerplate
  const [anchorEl, setAnchorEl] = createSignal<HTMLButtonElement | null>(null);
  const open = () => Boolean(anchorEl());
  const handleHover = (
    event: MouseEvent & { currentTarget: HTMLButtonElement },
  ) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //Popover Boilerplate
  return (
    <>
      <div
        // @ts-expect-error html click types...
        onMouseEnter={handleHover}
        onMouseLeave={handleClose}
      >
        {props.anchor}
      </div>
      <Show when={props.render}>
        <Popover
          open={open()}
          sx={{ 'pointer-events': 'none', 'margin-top': props.marginTop }}
          disableRestoreFocus
          anchorEl={anchorEl()}
          onClose={handleClose}
          dataTestId="hover-pop-popover"
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          {props.children}
        </Popover>
      </Show>
    </>
  );
};
